<template>
  <div class="banner">
    <div class="bg">
      <img src="@/assets/img/banner/leve2_bg.jpg" alt="" />
    </div>
    <div
      class="inner"
      :style="{ backgroundImage: `url(${bgData[$route.name]})` }"
    >
      <div class="bread" v-if="clientWidth > 900">
        <div @click="goTo('/home')">{{ $t("官網首頁") }}</div>
        <i class="el-icon-arrow-right"></i>
        <div>{{ module.title }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Banner",
  computed: {
    ...mapState({
      module: (state) => state.banner.module,
      clientWidth: (state) => state.screen.clientWidth,
    }),
  },
  data() {
    return {
      bgData: {
        Serve: require("@/assets/img/banner/serve.jpg"),
        Message: require("@/assets/img/banner/message.jpg"),
        Information: require("@/assets/img/banner/information.jpg"),
        Download: require("@/assets/img/banner/download.jpg"),
        Question: require("@/assets/img/banner/question.jpg"),
        Community: require("@/assets/img/banner/community.jpg"),
        Mall: require("@/assets/img/banner/mall.jpg"),
      },
    };
  },
  methods: {
    goTo(val) {
      this.$router.push(val);
    },
  },
};
</script>
<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 230px;

  // background-position: 100% 100%;
  // background-attachment:fixed;
  // background-size: 100% 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-direction: column;
  @media only screen and (max-width: 900px) {
    height: 80px;
  }
  .bg {
    width: 100%;
    flex: 1;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .inner {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    padding-bottom: 32px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    flex: 1;
    width: 100%;
    .title {
      font-size: 45px;
      color: #fff;
      letter-spacing: 5px;
      text-align: left;
    }
    .bread {
      color: #c6a86c;
      font-size: 16px;
      display: flex;
      align-items: flex-end;
      margin-right: 20%;
      &:first-child {
        cursor: pointer;
      }
      i {
        margin: 0 5px;
      }
    }
  }
}
</style>
